var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.statusToDisplay,"label":_vm.label,"chips":"","multiple":""},model:{value:(_vm.localStatus),callback:function ($$v) {_vm.localStatus=$$v},expression:"localStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }